import RaffleEventsContent from "./RaffleEventsContent";

export default RaffleEventsContent;